export default __webpack_public_path__ + "aa5af23552cce4699e71098994c831a6.png";